import { GetRandom } from "./utils";
import { v4 as uuidv4 } from "uuid";

const Globals = require("./globals");
const canvas = Globals.canvas;

const colors = [
  {
    name: "color01",
    color: "#feff9c",
  },
  {
    name: "color02",
    color: "#fff740",
  },
  {
    name: "color03",
    color: "#ff7eb9",
  },
  {
    name: "color04",
    color: "#ff65a3",
  },
  {
    name: "color05",
    color: "#7afcff",
  },
  {
    name: "color06",
    color: "#F6863D",
  },
  {
    name: "color07",
    color: "#d1e27c",
  },
];

let currentStickyColor = colors[0];

function Add(left, top, width = 200) {
  const id = uuidv4();

  var rect = new fabric.StickyRect({
    parent: id,
    width: width,
    fill: currentStickyColor.color,
  });

  var textbox = new fabric.StickyLabel("Type Here ...", {
    parent: id,
    width: width - 20,
  });

  var group = new fabric.Sticky([rect, textbox], {
    id: id,
    left: left,
    top: top,
    // angle: GetRandom(-0.5, 1),
    angle: GetRandom(-0.15, 0.15),
    isMyElem: true,
  });

  canvas.add(group);
  canvas.setActiveObject(group);

  canvas.fire("sticky:added", {
    target: group,
  });
}

function AddTextLabel(left, top) {
  var textbox = new fabric.TextLabel("Type Here ...", {
    id: uuidv4(),
    left,
    top,
    width: 300,
    angle: GetRandom(-0.15, 0.15),
  });

  canvas.add(textbox);
  canvas.setActiveObject(textbox);

  textbox.enterEditing();
  textbox.selectAll();

  canvas.fire("sticky:added", {
    target: textbox,
  });
}

function AddText(left, top) {
  var textbox = new fabric.TextNote("Type some text...", {
    id: uuidv4(),
    left,
    top,
    width: 400,
    height: 250,
    // angle: GetRandom(-0.5, 1),
    angle: GetRandom(-0.15, 0.15),
  });

  canvas.add(textbox);
  canvas.setActiveObject(textbox);

  textbox.enterEditing();
  textbox.selectAll();

  canvas.fire("sticky:added", {
    target: textbox,
  });
}

const colorControlProps = {
  x: -0.5,
  y: -0.5,
  offsetY: -30,
  cursorStyle: "pointer",
};

fabric.Group.prototype.hasControls = false;
fabric.Sticky.prototype.hasControls = true;

for (let i = 0; i < colors.length; i++) {
  fabric.Sticky.prototype.controls[colors[i].name] = new fabric.Control({
    ...colorControlProps,
    offsetX: i * 40 + 10,
    mouseUpHandler: setStickyColor(colors[i]),
    cornerSize: 34,
    render: renderIcon(colors[i].name),
  });
}

function setStickyColor(color) {
  return (eventData, transform) => {
    const target = transform.target.item(0);

    target.set("fill", color.color);
    canvas.renderAll();

    currentStickyColor = color;

    canvas.fire("sticky:changed", {
      target: target,
    });
  };
}

Mousetrap.bind(["command+f", "ctrl+f"], function (e) {
  var target = Globals.canvas.getActiveObject();

  if (!target) return;

  canvas.bringToFront(target);

  canvas.fire("layer:changed", {
    target: target,
  });

  canvas.discardActiveObject();

  e.preventDefault();
  e.stopPropagation();
});

Mousetrap.bind(["command+b", "ctrl+b"], function (e) {
  var target = Globals.canvas.getActiveObject();

  if (!target) return;

  canvas.sendToBack(target);

  canvas.fire("layer:changed", {
    target: target,
  });

  canvas.discardActiveObject();

  e.preventDefault();
  e.stopPropagation();
});

Mousetrap.bind("c", (e) => {
  const canvas = Globals.canvas;

  var vpt = canvas.viewportTransform;
  vpt[4] = 0;
  vpt[5] = 0;

  canvas.zoomToPoint({ x: 0, y: 0 }, 1);

  canvas.requestRenderAll();
});

Mousetrap.bind(["command+d", "ctrl+d"], function (e) {
  var target = Globals.canvas.getActiveObject();

  if (!target) return;

  if (target.type === "activeSelection") {
    e.preventDefault();
    e.stopPropagation();

    return;
  }

  var canvas = target.canvas;

  target.clone(function (cloned) {
    cloned.left += cloned.width + 10;
    cloned.top += 0;
    cloned.id = uuidv4();

    delete cloned.sender;

    canvas.add(cloned);
    canvas.setActiveObject(cloned);

    if (cloned.type === "sticky") {
      cloned.item(0).parent = cloned.id;
      cloned.item(1).parent = cloned.id;
    }

    canvas.fire("sticky:added", {
      target: cloned,
    });
  });

  e.preventDefault();
  e.stopPropagation();
});

function cloneObject(eventData, transform) {
  // TODO Generate new ids
  var target = transform.target;
  var canvas = target.canvas;
  target.clone(function (cloned) {
    cloned.left += cloned.width + 10;
    cloned.top += 0;
    cloned.id = uuidv4();
    delete cloned.sender;

    canvas.add(cloned);
    canvas.setActiveObject(cloned);

    canvas.fire("sticky:added", {
      target: cloned,
    });
  });
}

Mousetrap.bind(["backspace", "del"], function (e) {
  var target = Globals.canvas.getActiveObject();

  if (!target) return;

  var canvas = target.canvas;

  if (target.type === "activeSelection") {
    target._objects.forEach((element) => {
      canvas.remove(element);
      canvas.fire("sticky:removed", {
        target: element,
      });
    });

    canvas.discardActiveObject();
    canvas.requestRenderAll();

    return;
  }

  canvas.fire("sticky:removed", {
    target: target,
  });

  canvas.remove(target);
  canvas.requestRenderAll();

  return false;
});

function deleteObj(eventData, transform) {
  var target = transform.target;
  var canvas = target.canvas;

  canvas.fire("sticky:removed", {
    target: target,
  });

  canvas.remove(target);
  canvas.requestRenderAll();
}

function renderIcon(iconName) {
  const icon = document.createElement("img");
  icon.src = `./${iconName}.svg`;

  return function (ctx, left, top, styleOverride, fabricObject) {
    var size = this.cornerSize;
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(icon, -size / 2, -size / 2, size, size);
    ctx.restore();
  };
}

fabric.Group.prototype.on("deselected", function (options) {
  if (!options.target) return;
  delete options.target.isClicked;
});

fabric.Group.prototype.on("mousedown", (e) => {
  if (e.transform.corner) {
    return;
  }

  if (!e.target.isClicked) {
    e.target.isClicked = true;
    return;
  }

  const group = e.target;
  const rect = group.item(0);
  const textbox = group.item(1);
  const cnv = group.canvas;

  // textForEditing is temporary obj,
  // and will be removed after editing
  let textForEditing = new fabric.StickyEditLabel(textbox.text, {
    type: "StickyEdit",
    parent: group.id,
    scaleX: rect.scaleX,
    scaleY: rect.scaleY,
    angle: rect.angle,
    left: group.left + group.width / 2,
    top: group.top + group.height / 2,

    fontFamily: textbox.fontFamily,
    hasBorders: false,
    width: textbox.width,
    height: group.height,

    textAlign: "center",
    // splitByGrapheme: true,

    fontSize: textbox.fontSize,
    fill: "#000",
    backgroundColor: "transparent",
    originX: "center",
    originY: "center",

    breakWords: true,
    objectCaching: false,
    onInput: function (e) {
      if (
        this.width > textbox.width &&
        e.inputType !== "deleteContentBackward"
      ) {
        // const text = this.lastText || this.text.slice(0, -2);
        // console.log(text);
        // this.set({
        //   text: text,
        // });
        // this.lastText = text;
        // e.preventDefault();
        // e.stopPropagation();
        // return;
      }

      this.lastText = this.text;

      // if (
      //   this.width > textbox.width &&
      //   this._textLines.length > 3 &&
      //   e.inputType !== "deleteContentBackward"
      // ) {
      //   return;
      // }

      // Call parent class method
      this.callSuper("onInput", e);
    },
  });

  // hide group inside text
  textbox.visible = false;
  // note important, text cannot be hidden without this
  group.addWithUpdate();

  textForEditing.visible = true;
  // do not give controls, do not allow move/resize/rotation on this
  textForEditing.hasConstrols = false;

  // now add this temporary obj to canvas
  cnv.add(textForEditing);
  cnv.setActiveObject(textForEditing);
  // make the cursor showing
  textForEditing.enterEditing();
  textForEditing.selectAll();
  // textForEditing.selectionStart = textForEditing.text.length;
  // textForEditing.selectionLength = 0;

  // editing:exited means you click outside of the textForEditing
  textForEditing.on("editing:exited", () => {
    let newVal = textForEditing.text;
    // let oldVal = textbox.text;

    // then we check if text is changed
    // if (newVal !== oldVal) {
    textbox.set({
      text: newVal,
      visible: true,
    });

    // comment before, you must call this
    group.addWithUpdate();

    // we do not need textForEditing anymore
    textForEditing.visible = false;
    cnv.remove(textForEditing);

    // optional, buf for better user experience
    cnv.setActiveObject(group);
    // }
  });
});

export { Add, AddText, AddTextLabel };
